"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[3183],{

/***/ 95706:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ GiftHubPage_GiftHubPage)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/modules/dynamicPages/DynamicPageContentProvider.tsx + 3 modules
var DynamicPageContentProvider = __webpack_require__(640);
// EXTERNAL MODULE: ./src/components/layout/PageLayout/PageLayout.tsx
var PageLayout = __webpack_require__(89902);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/modules/dynamicPages/contexts.ts
var contexts = __webpack_require__(93341);
// EXTERNAL MODULE: ./src/compositions/dynamicPages/BodySection/BodySection.tsx + 4 modules
var BodySection = __webpack_require__(51877);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(73358);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 1 modules
var Image = __webpack_require__(85808);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/LinkCard/LinkCard.tsx






const LinkCard = (props)=>{
    const { title, titleSpacing = 8, to, className, description, background, mobileBackground, label, white } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Href/* default */.Z, {
        to: to,
        className: (0,clsx/* default */.Z)(className, "relative", !isMobile && "h-[304rem]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                className: (0,clsx/* default */.Z)("h-full w-full", isMobile && "object-cover"),
                src: isMobile ? mobileBackground : background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 w-full py-24 z-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx/* default */.Z)("px-24", {
                        "py-16 bg-black inline-block": label,
                        "text-white": white
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            message: title,
                            className: isMobile ? "mb-8" : `mb-${titleSpacing}`,
                            style: "h5",
                            html: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    message: description,
                                    style: "p2",
                                    tag: "span",
                                    html: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    className: "ml-8 mb-2",
                                    name: "other/long-arrow-right"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ const LinkCard_LinkCard = (LinkCard);

// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/messages.ts
/* harmony default export */ const messages = ({
    default: {
        giftSubscription: {
            title: {
                en: "Gift subscription"
            },
            description: {
                en: "Give the gift that keeps giving<br /> year-round with a Scentbird<br /> subscription."
            }
        },
        giftSets: {
            title: {
                en: "Gift sets"
            },
            description: {
                en: "Beat Santa at his own game<br /> with these luxe gift sets."
            }
        },
        theEdit: {
            title: {
                en: "The edit"
            },
            description: {
                en: `
          From candles to full-sized <br class="onlyMobile"/> body<br class="onlyDesktop"/> lotions,
          discover<br class="onlyMobile"/> scent beyond <br class="onlyDesktop" />the bottle in<br class="onlyMobile"/> The Edit.
      `
            }
        },
        holidayShop: {
            title: {
                en: 'Scentbird<br /> <span class="text-white">holiday shop</span>'
            },
            description: {
                en: 'Get into the holiday<br class="onlyDesktop" /> spirit with the most<br /> festive fragrances of<br class="onlyDesktop" /> the season.'
            }
        },
        giftCards: {
            title: {
                en: "Gift cards"
            },
            description: {
                en: "$25, $50 or $100"
            }
        },
        scentbirdSelect: {
            title: {
                en: '<span class="text-gold-30">Scentbird select</span>'
            },
            description: {
                en: `
        Curated collection of premium <br />
        perfumes and colognes <br />
        hand-picked by our team of <br />
        scent experts.
      `
            }
        },
        samples: {
            title: {
                en: "1.5ml samples<br />are here"
            },
            description: {
                en: "Check out these mini<br />perfumes, starting at<br />$4.95"
            }
        }
    },
    valentinesDay: {
        giftSets: {
            description: {
                en: "Beat Cupid at his own game with<br />these luxe gift sets they'll love."
            }
        },
        holidayShop: {
            title: {
                en: 'Scentbird<br /> <span class="text-white">valentine\'s shop</span>'
            },
            description: {
                en: `
          From sultry accords to <br class="onlyDesktop" />sweet <br class="onlyMobile" />gourmand blends, <br class="onlyDesktop" />
          they\'ll fall <br class="onlyMobile" />head-over-heels <br class="onlyDesktop" />for these gifts.
        `
            }
        }
    }
});

;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/images/giftSubscriptionDesktop.jpg
const giftSubscriptionDesktop_namespaceObject = __webpack_require__.p + "images/giftSubscriptionDesktop_fc3b31.jpg";
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/images/giftSetsDesktop.jpg
const giftSetsDesktop_namespaceObject = __webpack_require__.p + "images/giftSetsDesktop_581ab1.jpg";
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/images/theEditDesktop.jpg
const theEditDesktop_namespaceObject = __webpack_require__.p + "images/theEditDesktop_6f99ac.jpg";
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/images/holidayShopDesktop.jpg
const holidayShopDesktop_namespaceObject = __webpack_require__.p + "images/holidayShopDesktop_48de93.jpg";
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/images/scentbirdSelectDesktop.jpg
const scentbirdSelectDesktop_namespaceObject = __webpack_require__.p + "images/scentbirdSelectDesktop_1669a6.jpg";
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/images/giftCardDesktop.jpg
const giftCardDesktop_namespaceObject = __webpack_require__.p + "images/giftCardDesktop_e8a4e5.jpg";
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/images/giftSubscriptionMobile.jpg
const giftSubscriptionMobile_namespaceObject = __webpack_require__.p + "images/giftSubscriptionMobile_135c50.jpg";
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/images/giftSetsMobile.jpg
const giftSetsMobile_namespaceObject = __webpack_require__.p + "images/giftSetsMobile_573ffc.jpg";
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/images/theEditMobile.jpg
const theEditMobile_namespaceObject = __webpack_require__.p + "images/theEditMobile_d0294a.jpg";
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/images/holidayShopMobile.jpg
const holidayShopMobile_namespaceObject = __webpack_require__.p + "images/holidayShopMobile_d81fa6.jpg";
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/images/scentbirdSelectMobile.jpg
const scentbirdSelectMobile_namespaceObject = __webpack_require__.p + "images/scentbirdSelectMobile_7dd1ea.jpg";
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/images/giftCardMobile.jpg
const giftCardMobile_namespaceObject = __webpack_require__.p + "images/giftCardMobile_171412.jpg";
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/utils/data.ts












const data = {
    "gift-cards": {
        background: giftCardDesktop_namespaceObject,
        mobileBackground: giftCardMobile_namespaceObject
    },
    "gift-sets": {
        background: giftSetsDesktop_namespaceObject,
        mobileBackground: giftSetsMobile_namespaceObject
    },
    "gift-subscription": {
        background: giftSubscriptionDesktop_namespaceObject,
        mobileBackground: giftSubscriptionMobile_namespaceObject
    },
    "holiday-shop": {
        background: holidayShopDesktop_namespaceObject,
        mobileBackground: holidayShopMobile_namespaceObject
    },
    "the-edit": {
        background: theEditDesktop_namespaceObject,
        mobileBackground: theEditMobile_namespaceObject
    },
    "scentbird-select": {
        background: scentbirdSelectDesktop_namespaceObject,
        mobileBackground: scentbirdSelectMobile_namespaceObject
    },
    samples: {}
};

;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/utils/useLinkCards.tsx







const useLinkCards = ()=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    const isGiftHubEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftHub);
    return (0,react.useMemo)(()=>{
        return [
            {
                title: messages["default"].giftSubscription.title,
                titleSpacing: 12,
                description: messages["default"].giftSubscription.description,
                to: links/* default */.ZP.giftSubscription,
                white: true,
                ...data["gift-subscription"]
            },
            {
                title: messages["default"].giftSets.title,
                titleSpacing: 12,
                description: messages["default"].giftSets.description,
                to: links/* default */.ZP.giftSets.root,
                white: isMobile,
                ...data["gift-sets"]
            },
            {
                title: messages["default"].theEdit.title,
                description: messages["default"].theEdit.description,
                to: links/* default */.ZP.shop.theEdit,
                ...data["the-edit"]
            },
            {
                title: messages["default"].holidayShop.title,
                description: messages["default"].holidayShop.description,
                to: isGiftHubEnabled ? links/* default */.ZP.shop.holiday : links/* default */.ZP.shop.perfumes,
                ...data["holiday-shop"]
            },
            {
                title: messages["default"].scentbirdSelect.title,
                description: messages["default"].scentbirdSelect.description,
                label: true,
                to: links/* default */.ZP.scentbirdSelect,
                white: true,
                ...data["scentbird-select"]
            },
            {
                title: messages["default"].giftCards.title,
                description: messages["default"].giftCards.description,
                to: links/* default */.ZP.giftCard,
                white: !isMobile,
                ...data["gift-cards"]
            }
        ];
    }, [
        isGiftHubEnabled,
        isMobile
    ]);
};
/* harmony default export */ const utils_useLinkCards = (useLinkCards);

;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/CardsContainer.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const CardsContainer_module = ({"linkCard":"MH7RPS"});
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CardsContainer/CardsContainer.tsx







const CardsContainer = ()=>{
    const linkCardData = utils_useLinkCards();
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx/* default */.Z)("flex flex-wrap gap-16", isMobile ? "mt-40" : "mt-60"),
        children: linkCardData.map((props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LinkCard_LinkCard, {
                className: CardsContainer_module.linkCard,
                ...props
            }, props.title.toString()))
    });
};
/* harmony default export */ const CardsContainer_CardsContainer = (CardsContainer);

// EXTERNAL MODULE: ./local_modules/local-storage/index.ts + 2 modules
var local_storage = __webpack_require__(55222);
// EXTERNAL MODULE: ./local_modules/notifications/manager.ts
var manager = __webpack_require__(72065);
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CutOffNotification/messages.ts
/* harmony default export */ const CutOffNotification_messages = ({
    notification: {
        title: {
            en: "Sending a gift?"
        },
        text: {
            en: "Get it in time for the holidays! Order by December 11th at midnight."
        },
        valentinesDayText: {
            en: "Get your gifts in time! Order by January 29 at 11:59 EST."
        }
    }
});

;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/CutOffNotification/CutOffNotification.tsx






const CutOffNotification = ()=>{
    const isCutOffEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftHubNotification);
    const isGiftHubValentinesNotificationMessageEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftHubValentinesNotificationMessage);
    (0,react.useEffect)(()=>{
        if (isCutOffEnabled && !local_storage/* default */.Z.getSessionItem("cutOffNotification")) {
            (0,manager/* openNotification */.Ym)("plain", {
                title: CutOffNotification_messages.notification.title,
                text: isGiftHubValentinesNotificationMessageEnabled ? CutOffNotification_messages.notification.valentinesDayText : CutOffNotification_messages.notification.text,
                onClose: ()=>{
                    local_storage/* default */.Z.setSessionItem("cutOffNotification", true);
                }
            });
        }
    }, [
        isCutOffEnabled
    ]);
    return null;
};
/* harmony default export */ const CutOffNotification_CutOffNotification = (CutOffNotification);

;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/BodySection/BodySection.tsx






const BodySection_BodySection = ()=>{
    const data = (0,contexts/* useDynamicPageContent */.p)();
    if (data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BodySection/* default */.Z, {
            data: data.bodySection
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CutOffNotification_CutOffNotification, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsContainer_CardsContainer, {})
        ]
    });
};
/* harmony default export */ const components_BodySection_BodySection = (BodySection_BodySection);

// EXTERNAL MODULE: ./src/compositions/dynamicPages/HeroSection/HeroSection.tsx + 7 modules
var HeroSection = __webpack_require__(45914);
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/Hero/messages.ts
/* harmony default export */ const Hero_messages = ({
    header: {
        en: "Holiday"
    },
    subHeader: {
        en: "at Scentbird"
    },
    description: {
        en: "From full-sized fragrances and gift cards, to luxe gift sets, our collection of gifts is packed with everything you need to spread cheer this holiday season."
    }
});

;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/Hero/images/wrapItUp.svg
const wrapItUp_namespaceObject = __webpack_require__.p + "images-svg/wrapItUp_7f5749.svg";
;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/Hero/Hero.tsx





const Hero = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                className: "max-w-full",
                src: wrapItUp_namespaceObject
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "text-[80rem]/[96rem]",
                message: Hero_messages.header,
                color: "dark-red",
                style: "eye1",
                html: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "text-[32rem]/[38rem]",
                message: Hero_messages.subHeader,
                color: "gold-50",
                style: "eye1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mx-auto mt-16 max-w-[625rem]",
                message: Hero_messages.description,
                style: "p2",
                html: true
            })
        ]
    });
};
/* harmony default export */ const Hero_Hero = (Hero);

;// CONCATENATED MODULE: ./src/pages/GiftHubPage/components/HeroSection/HeroSection.tsx





const HeroSection_HeroSection = ()=>{
    const data = (0,contexts/* useDynamicPageContent */.p)();
    if (data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection/* default */.Z, {
            className: "text-center",
            data: data.heroSection
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Hero, {})
    });
};
/* harmony default export */ const components_HeroSection_HeroSection = (HeroSection_HeroSection);

;// CONCATENATED MODULE: ./src/pages/GiftHubPage/GiftHubPage.tsx







const GiftHubPage = ()=>{
    (0,react.useEffect)(()=>{
        (0,analytics/* track */.j)("Gifts page");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicPageContentProvider/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout/* default */.Z, {
            className: "bg-light-beige",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HeroSection_HeroSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BodySection_BodySection, {})
                ]
            })
        })
    });
};
/* harmony default export */ const GiftHubPage_GiftHubPage = (GiftHubPage);


/***/ })

}]);